import { useTranslation } from 'react-i18next';

import { Box, Card, Text } from '@ngsos/portal-ui';

import { forceApplicationRefresh } from '@/app/forceApplicationRefresh';
import { NgButton } from '@/ui';

export function ApplicationRefresh() {
  const { t } = useTranslation();

  return (
    <Card>
      <Box gap={8}>
        <Text variant="title" role="heading" aria-level={3}>
          {t('Settings_Title_Application')}
        </Text>
        <Text variant="muted">{t('Settings_Application_ForceRefreshDescription')}</Text>
      </Box>

      <div className="mt-3">
        <NgButton
          text={t('Settings_Application_ForceRefresh')}
          icon="fal fa-rotate-right"
          showProgress
          enableMultipleClickPrevention
          onClick={forceApplicationRefresh}
        />
      </div>
    </Card>
  );
}
